export default "__VITE_ASSET__ChhT5tgX__"